import { render } from "./ViBoardingDate.vue?vue&type=template&id=720f2b1a&scoped=true"
import script from "./ViBoardingDate.vue?vue&type=script&lang=js"
export * from "./ViBoardingDate.vue?vue&type=script&lang=js"

import "./ViBoardingDate.vue?vue&type=style&index=0&id=720f2b1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-720f2b1a"

export default script